import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_get_survey_by_loadcontainer_rptService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { loadContainerId?: number }): 
  Promise<{ result: { Id?: number, LoadContainerId?: number, LookupCode?: string, Surveys?: { id?: number, contextAppointmentId?: number, contextData?: string, contextLicensePlateId?: number, contextLocationId?: number, contextProjectId?: number, contextShipmentId?: number, contextShippingContainerId?: number, contextTaskId?: number, createdSysDateTime?: string, createdSysUser?: string, equipmentId?: number, operationContextData?: string, operationContextTypeId?: number, surveyDefinitionId?: number, Inputs?: { id?: number, inputText?: string, surveyElementId?: number, surveyId?: number, Element?: { id?: number, text?: string } }[], SurveyDefinition?: { id?: number, name?: string }, OperationContextType?: { Id?: number, Name?: string }, Equipment?: { Id?: number, LookupCode?: string } }[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { loadContainerId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LoadContainerId?: number, LookupCode?: string, Surveys?: { id?: number, contextAppointmentId?: number, contextData?: string, contextLicensePlateId?: number, contextLocationId?: number, contextProjectId?: number, contextShipmentId?: number, contextShippingContainerId?: number, contextTaskId?: number, createdSysDateTime?: string, createdSysUser?: string, equipmentId?: number, operationContextData?: string, operationContextTypeId?: number, surveyDefinitionId?: number, Inputs?: { id?: number, inputText?: string, surveyElementId?: number, surveyId?: number, Element?: { id?: number, text?: string } }[], SurveyDefinition?: { id?: number, name?: string }, OperationContextType?: { Id?: number, Name?: string }, Equipment?: { Id?: number, LookupCode?: string } }[] }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { loadContainerId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LoadContainerId?: number, LookupCode?: string, Surveys?: { id?: number, contextAppointmentId?: number, contextData?: string, contextLicensePlateId?: number, contextLocationId?: number, contextProjectId?: number, contextShipmentId?: number, contextShippingContainerId?: number, contextTaskId?: number, createdSysDateTime?: string, createdSysUser?: string, equipmentId?: number, operationContextData?: string, operationContextTypeId?: number, surveyDefinitionId?: number, Inputs?: { id?: number, inputText?: string, surveyElementId?: number, surveyId?: number, Element?: { id?: number, text?: string } }[], SurveyDefinition?: { id?: number, name?: string }, OperationContextType?: { Id?: number, Name?: string }, Equipment?: { Id?: number, LookupCode?: string } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      loadContainerId?: number    }) {
      return false;
    }
}
